export default {
  menuList: [
    // {
    //     menuId: 7,
    //     menuName: "模板",
    //     jumpUrl: "/pages/Demo",
    //     children: [],
    // },
    {
      menuId: 135,
      menuName: "消息模块",
      jumpUrl: "",
      children: [
        {
          menuId: 1,
          menuName: "我的消息",
          jumpUrl: "/message/messageList",
          children: [],
        },
        {
          menuId: 2,
          menuName: "系统公告",
          jumpUrl: "/message/sysNoticeList",
          children: [],
        },
        {
          menuId: 3,
          menuName: "消息通知",
          jumpUrl: "/message/noticeList",
          children: [],
        },
      ],
    },
    {
      menuId: 131,
      menuName: "业务订单",
      jumpUrl: "",
      children: [
        {
          menuId: 1,
          menuName: "运单管理",
          jumpUrl: "",
          children: [
            {
              menuId: 1,
              menuName: "提货指令列表",
              jumpUrl: "/WaybillManage/NewPickupInstructionList",
              children: [],
            },
            {
              menuId: 2,
              menuName: "全部运单",
              jumpUrl: "/WaybillManage/ComprehensiveQuery",
              children: [],
            },
            {
              menuId: 2,
              menuName: "综合查询",
              jumpUrl: "/WaybillManage/sumAll/ComprehensiveQuerySumAll",
              children: [],
            },
            {
              menuId: 3,
              menuName: "新建运单",
              jumpUrl: "/WaybillManage/WaybillCreateRX",
              children: [],
            },
            {
              menuId: 4,
              menuName: "运单过账",
              jumpUrl: "/WaybillManage/WaybillPostingRX",
              children: [],
            },
            {
              menuId: 4,
              menuName: "运单应收过账",
              jumpUrl: "/WaybillManage/financeIn/List",
              children: [],
            },
            {
              menuId: 4,
              menuName: "运单应付过账",
              jumpUrl: "/WaybillManage/financeOut/List",
              children: [],
            },
            {
              menuId: 4,
              menuName: "运单其他收入过账",
              jumpUrl: "/WaybillManage/financeOther/List",
              children: [],
            },
            {
              menuId: 4,
              menuName: "运单跟踪",
              jumpUrl: "/WaybillManage/TrackingWaybill",
              children: [],
            },
            {
              menuId: 1,
              menuName: "运单签收",
              jumpUrl: "/WaybillManage/sign/sign",
              children: [],
            },
            {
              menuId: 1,
              menuName: "到货通知",
              jumpUrl: "/BusinessOrder/DeliveryNotice",
              children: [],
            },
            // {
            //   menuId: 1,
            //   menuName: "新建运单",
            //   jumpUrl: "/WaybillManage/WaybillCreate",
            //   children: [],
            // },
            // {
            //   menuId: 1,
            //   menuName: "运单导入",
            //   jumpUrl: "/WaybillManage/Waybillimport",
            //   children: [],
            // },
            // {
            //   menuId: 1,
            //   menuName: "动态查询",
            //   jumpUrl: "/WaybillManage/TestPage",
            //   children: [],
            // },
          ],
        },
        {
          menuId: 1,
          menuName: "外发管理",
          jumpUrl: "",
          children: [
            {
              menuId: 1,
              menuName: "待外发录入列表",
              jumpUrl: "/OutgoingManage/PendingOutboundEntry/List",
              children: [],
            },
            {
              menuId: 1,
              menuName: "外发列表",
              jumpUrl: "/OutgoingManage/OutgoingManage",
              children: [],
            },
            // {
            //   menuId: 1,
            //   menuName: "新建外发",
            //   jumpUrl: "/OutgoingManage/OutgoingAdd",
            //   children: [],
            // },
            // {
            //     menuId: 1,
            //     menuName: "外发过账",
            //     jumpUrl: "/OutgoingManage/OutgoingPosting",
            //     children: [],
            // },
          ],
        },
        {
          menuId: 1,
          menuName: "异常管理",
          jumpUrl: "",
          children: [
            {
              menuId: 1,
              menuName: "异常列表",
              jumpUrl: "/ExceptionManage/ExceptionManage",
              children: [],
            },
            {
              menuId: 1,
              menuName: "新建异常",
              jumpUrl: "/ExceptionManage/ExceptionAdd",
              children: [],
            },
            {
              menuId: 1,
              menuName: "不合格服务列表",
              jumpUrl: "/ExceptionManage/UnqualifiedList",
              children: [],
            },
            {
              menuId: 1,
              menuName: "异常总表",
              jumpUrl: "/ExceptionManage/AbnormalSummaryTable",
              children: [],
            },
            {
              menuId: 1,
              menuName: "异常表-客户",
              jumpUrl: "/ExceptionManage/AbnormalTableCustomers",
              children: [],
            },
            // {
            //     menuId: 1,
            //     menuName: "跟进异常",
            //     jumpUrl: "/ExceptionManage/ExceptionEdit",
            //     children: [],
            // },
          ],
        },
        {
          menuId: 1,
          menuName: "数据导入",
          jumpUrl: "",
          children: [
            {
              menuId: 1,
              menuName: "运单导入-客户",
              jumpUrl: "/DataImport/WaybillImport",
              children: [],
            },
          ],
        },
        {
          menuId: 1,
          menuName: "回单管理",
          jumpUrl: "/BusinessOrder/ReceiptManage",
          children: [],
        },
      ],
    },
    {
      menuId: 132,
      menuName: "调度派车",
      jumpUrl: "",
      children: [
        {
          menuId: 1,
          menuName: "提货调度",
          jumpUrl: "/DispatchCar/PickupScheduling",
          children: [],
        },
        {
          menuId: 1,
          menuName: "发车应付过账",
          jumpUrl: "/DispatchCar/financeIn",
          children: [],
        },
        {
          menuId: 1,
          menuName: "提货派车",
          jumpUrl: "/DispatchCar/shangmentihuo",
          children: [],
        },
        {
          menuId: 1,
          menuName: "干线派车",
          jumpUrl: "/DispatchCar/ganxian",
          children: [],
        },
        {
          menuId: 1,
          menuName: "送货上门",
          jumpUrl: "/DispatchCar/songhuoshangmen",
          children: [],
        },
        {
          menuId: 1,
          menuName: "送出外发",
          jumpUrl: "/DispatchCar/songchuwaifa",
          children: [],
        },
        {
          menuId: 1,
          menuName: "车费摊分",
          jumpUrl: "/DispatchCar/PickupDispatchCar/allocation/fee",
          children: [],
        },
        {
          menuId: 1,
          menuName: "在途跟踪",
          jumpUrl: "/DispatchCar/OnwayTrace/list",
          children: [],
        },
        {
          menuId: 1,
          menuName: "到车管理",
          jumpUrl: "/DispatchCar/FinishCar/finishCar",
          children: [],
        },
        {
          menuId: 1,
          menuName: "车次详情",
          jumpUrl: "/DispatchCar/CarTiming",
          children: [],
        },
        {
          menuId: 1,
          menuName: "运单配载",
          jumpUrl: "/DispatchCar/WaybillLoading",
          children: [],
        },
        {
          menuId: 1,
          menuName: "接收调度员",
          jumpUrl: "/DispatchCar/ReceivingDispatcher",
          children: [],
        },
        {
          menuId: 1,
          menuName: "送货调度",
          jumpUrl: "/DispatchCar/DeliveryScheduling",
          children: [],
        },
        {
          menuId: 1,
          menuName: "外发调度",
          jumpUrl: "/DispatchCar/OutgoingDispatch",
          children: [],
        },
        // {
        //   menuId: 1,
        //   menuName: "干线调度",
        //   jumpUrl: "/DispatchCar/MainlineDispatch",
        //   children: [],
        // },
        // {
        //   menuId: 1,
        //   menuName: "运输规划",
        //   jumpUrl: "/DispatchCar/AddTransportationPlan",
        //   children: [],
        // },
        // {
        //   menuId: 1,
        //   menuName: "运输任务",
        //   jumpUrl: "/DispatchCar/TransportationPlann",
        //   children: [],
        // },
        // {
        //   menuId: 1,
        //   menuName: "新建配载",
        //   jumpUrl: "/DispatchCar/NewStowageAdd",
        //   children: [],
        // },
        {
          menuId: 1,
          menuName: "配载批次",
          jumpUrl: "/DispatchCar/VehicleStowage",
          children: [],
        },
        // {
        //   menuId: 1,
        //   menuName: "待配载任务",
        //   jumpUrl: "/DispatchCar/TasksLoaded",
        //   children: [],
        // },
        // {
        //   menuId: 1,
        //   menuName: "车辆轨迹查询",
        //   jumpUrl: "/DispatchCar/VehicleTrajectoryQuery",
        //   children: [],
        // },
        // {
        //   menuId: 1,
        //   menuName: "已配载任务",
        //   jumpUrl: "/DispatchCar/LoadedTasks",
        //   children: [],
        // },
        // {
        //   menuId: 1,
        //   menuName: "发车详情",
        //   jumpUrl: "/DispatchCar/dispatchCarDetails",
        //   children: [],
        // },
        // {
        //   menuId: 1,
        //   menuName: "退单审核",
        //   jumpUrl: "/DispatchCar/ChargebackAudit",
        //   children: [],
        // },
        {
          menuId: 1,
          menuName: "发车合同管理",
          jumpUrl: "/DispatchCar/DepartureContractManagement",
          children: [],
        },
        {
          menuId: 1,
          menuName: "装货作业单",
          jumpUrl: "/DispatchCar/LoadingOperationSheet",
          children: [],
        },
        {
          menuId: 1,
          menuName: "卸货作业单",
          jumpUrl: "/DispatchCar/UnloadingOperationSheet",
          children: [],
        },
      ],
    },
    {
      menuId: 133,
      menuName: "仓库管理",
      jumpUrl: "",
      children: [
        {
          menuId: 1,
          menuName: "运单库存",
          jumpUrl: "/WarehouseManagement/WaybillInventory",
          children: [],
        },
        {
          menuId: 1,
          menuName: "在途运单",
          jumpUrl: "/WarehouseManagement/InTransitWaybill",
          children: [],
        },
        {
          menuId: 1,
          menuName: "出库确认",
          jumpUrl: "/WarehouseManagement/DeliveryConfirm",
          children: [],
        },
        {
          menuId: 1,
          menuName: "入库确认",
          jumpUrl: "/WarehouseManagement/WarehousingConfirm",
          children: [],
        },
        // {
        //   menuId: 1,
        //   menuName: "出入库记录",
        //   jumpUrl: "/WarehouseManagement/ReceiptIssueRecord",
        //   children: [],
        // },
        {
          menuId: 1,
          menuName: "装卸单",
          jumpUrl: "/WarehouseManagement/loadeUnloadeOrder",
          children: [],
        },
        {
          menuId: 1,
          menuName: "待分拣运单",
          jumpUrl: "/WarehouseManagement/WaybillSorted",
          children: [],
        },
        {
          menuId: 1,
          menuName: "包装分拣",
          jumpUrl: "/WarehouseManagement/PackagingSorting",
          children: [],
        },
        {
          menuId: 1,
          menuName: "库存管理",
          jumpUrl: "/WarehouseManagement/stock/list",
          children: [],
        },
        {
          menuId: 1,
          menuName: "库区管理",
          jumpUrl: "/WarehouseManagement/storage/list",
          children: [],
        },
        {
          menuId: 1,
          menuName: "出入库记录",
          jumpUrl: "/WarehouseManagement/stock/history",
          children: [],
        },
      ],
    },
    // 财务管理
    {
      menuId: 134,
      menuName: "财务管理",
      jumpUrl: "",
      children: [
        {
          menuId: 1,
          menuName: "费用报销",
          jumpUrl: "/FinancialManagement/ExpenseReimbursement",
          children: [],
        },
        {
          menuId: 1,
          menuName: "财务核销",
          jumpUrl: "",
          children: [
            {
              menuId: 1,
              menuName: "应收核销总表",
              jumpUrl: "/FM/receivableWriteOff",
              children: [],
            },
            {
              menuId: 2,
              menuName: "应付核销总表",
              jumpUrl: "/FM/PayableWriteoff",
              children: [],
            },
            {
              menuId: 2,
              menuName: "客户核销总表",
              jumpUrl:
                "/FinancialManagement/FinancialWriteOff/CustomerVerificationSummary",
              children: [],
            },
            {
              menuId: 2,
              menuName: "承运商核销总表",
              jumpUrl:
                "/FinancialManagement/FinancialWriteOff/CarrierVerificationSummary",
              children: [],
            },
            {
              menuId: 3,
              menuName: "运单应收核销",
              jumpUrl: "/FM/WaybillReceivable",
              children: [],
            },
            {
              menuId: 4,
              menuName: "异常单核销",
              jumpUrl: "/FM/UOF",
              children: [],
            },
            {
              menuId: 5,
              menuName: "外发单核销",
              jumpUrl: "/FM/Outbound",
              children: [],
            },
            {
              menuId: 6,
              menuName: "发车单核销",
              jumpUrl: "/FM/Depart",
              children: [],
            },
            {
              menuId: 7,
              menuName: "其他收入核销",
              jumpUrl: "/FM/FW/OtherIncome",
              children: [],
            },
            {
              menuId: 8,
              menuName: "其他支出核销",
              jumpUrl: "/FM/FW/OtherExpenses",
              children: [],
            },
            {
              menuId: 9,
              menuName: "车辆成本核销",
              jumpUrl: "/FM/VehicleCost",
              children: [],
            },
            {
              menuId: 10,
              menuName: "对账单核销",
              jumpUrl: "/FM/BillWriteoff",
              children: [],
            },
            // {
            //     menuId: 11,
            //     menuName: "订单应收",
            //     jumpUrl: "/FM/OrderReceivable",
            //     children: [],
            // },
            // {
            //     menuId: 12,
            //     menuName: "订单应付",
            //     jumpUrl: "/FM/OrderPayable",
            //     children: [],
            // },
            // {
            //   menuId: 13,
            //   menuName: "代收货款",
            //   jumpUrl: "/FM/CollectLoans",
            //   children: [],
            // },
            {
              menuId: 13,
              menuName: "代收货款收回",
              jumpUrl: "/FM/agent/revoke",
              children: [],
            },
            {
              menuId: 14,
              menuName: "代收货款支付",
              jumpUrl: "/FM/agent/pay",
              children: [],
            },
          ],
        },

        {
          menuId: 3,
          menuName: "资金管理",
          jumpUrl: "",
          children: [
            {
              menuId: 1,
              menuName: "资金账号",
              jumpUrl: "/FM/FundAccountNo",
              children: [],
            },
            {
              menuId: 2,
              menuName: "资金调拨",
              jumpUrl: "/FM/FundAllocation",
              children: [],
            },
            {
              menuId: 2,
              menuName: "借支单",
              jumpUrl: "/FM/DebitNote",
              children: [],
            },
            {
              menuId: 3,
              menuName: "资金流水账",
              jumpUrl: "/FM/CapitalDaybook",
              children: [],
            },
          ],
        },
        {
          menuId: 3,
          menuName: "报价管理",
          jumpUrl: "",
          children: [
            //     {
            //     menuId: 1,
            //     menuName: "费项设置",
            //     jumpUrl: "/FM/SetExpenditure",
            //     children: [],
            // },
            {
              menuId: 2,
              menuName: "费项类型维护",
              jumpUrl: "/FM/MtExpenditure",
              children: [],
            },
          ],
        },
        {
          menuId: 1,
          menuName: "其他收入",
          jumpUrl: "/FM/OtherIncome",
          children: [],
        },
        {
          menuId: 1,
          menuName: "其他支出",
          jumpUrl: "/FM/OtherExpenses",
          children: [],
        },
        // {
        //     menuId: 1,
        //     menuName: "应收应付审核总表",
        //     jumpUrl: "/FM/ARAPSummary",
        //     children: [],
        // },
        // {
        //   menuId: 1,
        //   menuName: "发票管理",
        //   jumpUrl: "/FM/InvoicesControl",
        //   children: [],
        // },
        {
          menuId: 1,
          menuName: "发票管理",
          jumpUrl: "/FM/InvoicesControlRX",
          children: [],
        },
      ],
    },
    {
      menuId: 132,
      menuName: "报表分析",
      jumpUrl: "",
      children: [
        {
          menuId: 0,
          menuName: "报表管理",
          jumpUrl: "/FM/ReportManager",
          children: [],
        },
        // {
        //   menuId: 1,
        //   menuName: "客户损益表",
        //   jumpUrl: "/FM/CustomPL",
        //   children: [],
        // },
        // {
        //   menuId: 2,
        //   menuName: "运单损益表",
        //   jumpUrl: "/FM/TransportPL",
        //   children: [],
        // },
        // {
        //   menuId: 3,
        //   menuName: "车辆损益表",
        //   jumpUrl: "/FM/VehiclePL",
        //   children: [],
        // },
        // {
        //   menuId: 4,
        //   menuName: "部门损益表",
        //   jumpUrl: "/FM/DepartPL",
        //   children: [],
        // },
        // {
        //   menuId: 5,
        //   menuName: "司机押运费用",
        //   jumpUrl: "/FM/DriverEscort",
        //   children: [],
        // },
        // {
        //   menuId: 6,
        //   menuName: "装卸费用清单",
        //   jumpUrl: "/FM/StevedoreCost",
        //   children: [],
        // },
        // {
        //   menuId: 7,
        //   menuName: "运单车费分摊清单",
        //   jumpUrl: "/FM/TransportFare",
        //   children: [],
        // },
        // {
        //   menuId: 8,
        //   menuName: "应收账款明细",
        //   jumpUrl: "/FM/BillsDetailed",
        //   children: [],
        // },
        // {
        //   menuId: 9,
        //   menuName: "外发应付账款明细", //report_form:
        //   jumpUrl: "/FM/OutboundDetailed",
        //   children: [],
        // },
        // {
        //   menuId: 10,
        //   menuName: "外请应付账款明细",
        //   jumpUrl: "/FM/InviteDetailed",
        //   children: [],
        // },
        // {
        //   menuId: 11,
        //   menuName: "车辆配载",
        //   jumpUrl: "/FM/VehicleStowage",
        //   children: [],
        // },
      ],
    },
    // 客商管理
    {
      menuId: 135,
      menuName: "客商管理",
      jumpUrl: "",
      children: [
        {
          menuId: 1,
          menuName: "承运商档案",
          jumpUrl: "/Customers/NVOCC",
          children: [],
        },
        {
          menuId: 2,
          menuName: "客户档案",
          jumpUrl: "/Customers/Custom",
          children: [],
        },
        {
          menuId: 3,
          menuName: "收货人查询",
          jumpUrl: "/Customers/Consignee",
          children: [],
        },
        {
          menuId: 4,
          menuName: "发货人查询",
          jumpUrl: "/Customers/Consignor",
          children: [],
        },
      ],
    },
    // 车辆管理
    {
      menuId: 136,
      menuName: "车辆管理",
      jumpUrl: "",
      children: [
        {
          menuId: 1,
          menuName: "车辆档案",
          jumpUrl: "/VMS/CarArchive",
          children: [],
        },
        {
          menuId: 2,
          menuName: "司机档案",
          jumpUrl: "/VMS/DriverArchive",
          children: [],
        },
        {
          menuId: 9,
          menuName: "车辆保险",
          jumpUrl: "/VMS/VehicleInsurance",
          children: [],
        },
        {
          menuId: 3,
          menuName: "油卡档案",
          jumpUrl: "/VMS/GasArchive",
          children: [],
        },
        {
          menuId: 4,
          menuName: "油卡申领记录",
          jumpUrl: "/VMS/GasApply",
          children: [],
        },
        {
          menuId: 5,
          menuName: "车辆成本",
          jumpUrl: "/VMS/VOCApply",
          children: [],
        },
        {
          menuId: 6,
          menuName: "加油记录",
          jumpUrl: "/VMS/GasupRecord",
          children: [],
        },
        {
          menuId: 7,
          menuName: "油卡充值",
          jumpUrl: "/VMS/GascardEtc",
          children: [],
        },
        {
          menuId: 8,
          menuName: "油卡流水账",
          jumpUrl: "/VMS/GascardDaybook",
          children: [],
        },
      ],
    },

    {
      menuId: 137,
      menuName: "系统设置",
      jumpUrl: "",
      children: [
        {
          menuId: 1,
          menuName: "账号管理",
          jumpUrl: "/SystemSetting/AccountManagement",
          children: [],
        },
        {
          menuId: 1,
          menuName: "角色管理",
          jumpUrl: "/SystemSetting/RoleManagement",
          children: [],
        },
        {
          menuId: 1,
          menuName: "员工管理",
          jumpUrl: "/SystemSetting/EmployeeManagement",
          children: [],
        },
        {
          menuId: 1,
          menuName: "操作日志",
          jumpUrl: "/SystemSetting/OperationLog",
          children: [],
        },
        {
          menuId: 1,
          menuName: "数据字典",
          jumpUrl: "/SystemSetting/DataDictionary",
          children: [],
        },
        {
          menuId: 1,
          menuName: "app版本管理",
          jumpUrl: "/SystemSetting/AppVersionManagement",
          children: [],
        },
        {
          menuId: 1,
          menuName: "logo设置",
          jumpUrl: "/SystemSetting/LogoSettings",
          children: [],
        },
      ],
    },
    {
      menuId: 137,
      menuName: "基础数据",
      jumpUrl: "",
      children: [
        {
          menuId: 1,
          menuName: "地址薄",
          jumpUrl: "/SystemSetting/AddressBook",
          children: [],
        },
        {
          menuId: 1,
          menuName: "发票抬头",
          jumpUrl: "/SystemSetting/InvoiceHeader",
          children: [],
        },
        {
          menuId: 1,
          menuName: "企业资质",
          jumpUrl: "/SystemSetting/Qualifications",
          children: [],
        },
        {
          menuId: 1,
          menuName: "异常原因",
          jumpUrl: "/SystemSetting/AbnormalCause",
          children: [],
        },
        {
          menuId: 1,
          menuName: "基础数据配置",
          jumpUrl: "/SystemSetting/BasicDataConfiguration",
          children: [],
        },
        {
          menuId: 1,
          menuName: "地区维护",
          jumpUrl: "/SystemSetting/RegionalMaintenance",
          children: [],
        },
        {
          menuId: 1,
          menuName: "组织架构",
          jumpUrl: "/SystemSetting/organizationalStructure",
          children: [],
        },
        {
          menuId: 1,
          menuName: "运输路线",
          jumpUrl: "/SystemSetting/TransportLine",
          children: [],
        },
        // {
        //   menuId: 1,
        //   menuName: "文章管理",
        //   jumpUrl: "/SystemSetting/ArticleManagement",
        //   children: [],
        // },

        // {
        //     menuId: 1,
        //     menuName: "系统VI设置",
        //     jumpUrl: "/SystemSetting/SystemVISettings",
        //     children: [],
        // },
        {
          menuId: 1,
          menuName: "货物品类及类型",
          jumpUrl: "/SystemSetting/GoodsCategoryType",
          children: [],
        },
        {
            menuId: 1,
            menuName: "货物品类",
            jumpUrl: "/SystemSetting/GoodsCategory",
            children: [],
        },
        {
          menuId: 1,
          menuName: "货物维护",
          jumpUrl: "/SystemSetting/CargoMaintenance",
          children: [],
        },
      ],
    },
  ],
};
